import styled from 'styled-components';
import TabButtonGray from '../TabButtonGray';

const TabButtonNoHover = styled(TabButtonGray)`
  :hover {
    color: rgba(0, 0, 0, 0.35);
  }
`;
export default TabButtonNoHover;
